import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { catchError, of, tap } from 'rxjs';
import { EIconPath } from '../../shared/enums/icons.enum';
import { ImageCacheService } from './image-cache.service';

@Directive({
    selector: '[ppSecureSrc]',
    standalone: false
})
export class SecureSrcDirective implements OnChanges {
  @Input('ppSecureSrc') src: string;

  constructor(
    private elementRef: ElementRef,
    private imageCacheService: ImageCacheService,
  ) {}

  ngOnChanges(): void {
    if (this.src) {
      this.loadImage();
    }
  }

  private loadImage(): void {
    this.imageCacheService
      .getImageUrl(this.src)
      .pipe(
        tap((blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            this.setImageSrc(url);
          } else {
            this.setImageSrc(EIconPath.PLACEHOLDER_IMAGE);
          }
        }),
        catchError((error) => {
          this.setImageSrc(EIconPath.PLACEHOLDER_IMAGE);

          return of(error);
        }),
      )
      .subscribe();
  }

  private setImageSrc(source: string): void {
    const imgElement = this.elementRef.nativeElement;

    if (imgElement.src) {
      URL.revokeObjectURL(imgElement.src);
    }

    imgElement.src = source;

    imgElement.onload = (): void => {
      URL.revokeObjectURL(EIconPath.PLACEHOLDER_IMAGE);
    };
  }
}
